import __vue_component__ from '../HseIcon/HseIcon.vue.js';
import { inputMaskMixin } from './inputMaskMixin.js';

//

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=313%3A79
 * @storybook /?path=/story/inputs-input--playground
 * @react /src-components-input
 * @reactStorybook /?path=/story/inputs-input--playground
 * @hideSlot default
 * @slot left Иконка слева
 * @slot right Иконка справа
 */
var script = {
  name: 'HseInput',
  inheritAttrs: false,
  components: {
    HseIcon: __vue_component__
  },
  mixins: [inputMaskMixin],
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    /**
     * Текущее значение
     */
    value: {
      default: ''
    },
    /**
     * Размер компонента
     * @values small, medium, large
     */
    size: {
      type: String,
      validator: (v) => ['small', 'medium', 'large'].includes(v),
      default: 'medium'
    },
    /**
     * Состояние ошибки
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Полная ширина компонента
     */
    fullWidth: {
      type: Boolean,
      default: false
    },
    /**
     * Иконка слева
     */
    leftIcon: {
      type: [String, Object],
      default: null
    },
    /**
     * Иконка справа
     */
    rightIcon: {
      type: [String, Object],
      default: null
    },
    /**
     * Дополнительные классы элементов:
     * - input - элемент input
     * - icon - иконки слева и справа
     * - iconLeft - иконка слева
     * - iconRight - иконка справа
     * @type {{
        icon?: string,
        iconLeft?: string,
        iconRight?: string,
        input?: string
     * }}
     */
    classes: {
      type: Object,
      default: () => ({
        icon: '',
        iconLeft: '',
        iconRight: '',
        input: ''
      })
    }
  },
  data() {
    return {
      focused: false
    };
  },
  methods: {
    onInput(e) {
      const $input = e.target;
      if (this.inputMask) {
        /**
         * Текущее значение инпута без маски. Вызывается при наличии маски
         * @type {string}
         */
        this.$emit('input:unmasked', this.inputMask.getUnmaskedValue());
      }
      /**
       * Текущее значение input
       * @type {string}
       */
      this.$emit('input', $input.value);
      this.$nextTick(() => {
        if ($input.value !== this.value) {
          $input.value = this.value;
        }
      });
    },
    onFocus(e) {
      this.focused = true;
      /**
       * Событие фокуса
       * @type {FocusEvent}
       */
      this.$emit('focus', e);
    },
    onBlur(e) {
      this.focused = false;
      /**
       * Событие потери фокуса
       * @type {FocusEvent}
       */
      this.$emit('blur', e);
    },
    focusInput() {
      this.$refs.input.focus();
    }
  },
  computed: {
    rightIconSlotName() {
      return this.$slots['right-icon'] ? 'right-icon' : 'right'
    },
    leftIconSlotName() {
      return this.$slots['left-icon'] ? 'left-icon' : 'left'
    },
    iconSize() {
      return this.size === 'small' ? 'small' : 'medium'
    },
    inputListeners() {
      return {
        ...this.$listeners,
        blur: this.onBlur,
        focus: this.onFocus,
        input: this.onInput
      }
    }
  }
};

export default script;
